import { render } from "./ComponentProduct.vue?vue&type=template&id=a1d021e4&scoped=true"
import script from "./ComponentProduct.vue?vue&type=script&lang=js"
export * from "./ComponentProduct.vue?vue&type=script&lang=js"

import "./ComponentProduct.vue?vue&type=style&index=0&id=a1d021e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d021e4"]])

export default __exports__